import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './carousel-fullwidth.component.scss';
var CarouselFullwidth = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselFullwidth, _super);
    function CarouselFullwidth(element) {
        return _super.call(this, element) || this;
    }
    CarouselFullwidth.prototype.init = function () {
        this.modal = this.element;
        this.modalLinks = Array.from(document.querySelectorAll('.js-gallery-modal-open'));
        this.modalCloseButton = Array.from(this.element.querySelectorAll('.js-gallery-modal-close'));
    };
    CarouselFullwidth.prototype.bindEvents = function () {
        var _this = this;
        this.modalLinks.map(function (button) { return button.addEventListener('click', function (event) {
            var elementButton;
            if (event.currentTarget) {
                elementButton = event.currentTarget;
            }
            else {
                elementButton = event.target;
            }
            var modalSelected = elementButton.getAttribute('data-modal');
            var indexSelected = elementButton.getAttribute('data-index');
            if (_this.modal.getAttribute('data-modal') === modalSelected) {
                _this.modal.classList.add('carousel-fullwidth__modal--opened');
                _this.initCarousel(indexSelected);
            }
        }); });
        this.modalCloseButton.map(function (button) { return button.addEventListener('click', function (event) {
            var elementButton;
            if (event.currentTarget) {
                elementButton = event.currentTarget;
            }
            else {
                elementButton = event.target;
            }
            _this.modal.classList.remove('carousel-fullwidth__modal--opened');
        }); });
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            }
            else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                _this.modal.classList.remove('carousel-fullwidth__modal--opened');
            }
        };
    };
    CarouselFullwidth.prototype.initCarousel = function (initialSlide) {
        if (initialSlide === void 0) { initialSlide = 0; }
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = Array.from(this.element.querySelectorAll('.swiper-button-next'));
        this.sliderPrev = Array.from(this.element.querySelectorAll('.swiper-button-prev'));
        this.windowWidth = document.documentElement.clientWidth;
        switch (this.sliderItems) {
            case 1:
                this.breakpoints = {};
                break;
            case 2:
                this.breakpoints = {
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 15,
                    }
                };
                break;
            default:
                this.breakpoints = {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 15,
                    }
                };
                break;
        }
        this.sliderConfig = {
            slidesPerView: this.sliderItems,
            spaceBetween: 0,
            initialSlide: initialSlide - 1,
            breakpoints: this.breakpoints,
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    return CarouselFullwidth;
}(Base));
export { CarouselFullwidth };



//////////////////
// WEBPACK FOOTER
// ./components/carousel-fullwidth/carousel-fullwidth.component.ts
// module id = 191
// module chunks = 0